/* script */
//
//
//
//
//

import action from './action';
import copyLink from './copy-link';

const __vue_script__ = {
    name: 'CopyPermalinkButton',

    mixins: [action, copyLink],

    props: {
        name: {
            type: String,
            required: true
        },

        path: {
            type: String,
            default: null
        },

        linkUrl: {
            type: String,
            default: null
        },

        label: {
            type: String,
            default: null
        },

        params: {
            type: [Object, Array],
            default: () => undefined
        }
    },

    data() {
        return {
            url: null,
            enabled: this.$services.user.hasPermission('node_crud_realms.create_doc', {
                event_id: this.event._id,
                org_id: this.event.ownerId
            }),
            buttonLabel: this.label ? this.label : this.$t('listings.actions.copy_permalink')
        };
    },

    methods: {
        async copyPermalink() {
            let url = this.linkUrl;
            if (!url) {
                const name = this.$utils.dom.compile(this.name, this.item);
                const path = this.$utils.url.interpolateUrl(this.path, {
                    eventId: event._id,
                    ...this.item
                });
                url = await this.$services.deepLink.getLink(this.event._id, path, undefined, this.item._id, name, this.params);
            }
            this.url = url;
            await this.copyLink(url);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('button',{staticClass:"copy-permalink btn btn-icon",attrs:{"type":"button","data-url":_vm.url},on:{"click":function($event){$event.stopPropagation();return _vm.copyPermalink.apply(null, arguments)}}},[_c('i',{staticClass:"ic-link"}),_vm._v(_vm._s(_vm.buttonLabel))]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CopyPermalinkButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__